export default __webpack_public_path__ + "static/media/videodoor.3559d928.jpg";